import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ResponseApi } from '../../../../dtos/response-api';
import { Observable } from 'rxjs';
import { Estado } from '../../../../dtos/sai/core/estado';

@Injectable({
  providedIn: 'root'
})
export class EstadoService {

  private baseUrl = `${environment.apiUrl}/sai/core/estado`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<Estado[]>> {
    return this.http.get<ResponseApi<Estado[]>>(this.baseUrl);
  }


  getEstadosWithOrgao(): Observable<ResponseApi<Estado[]>> {
    return this.http.get<ResponseApi<Estado[]>>(`${this.baseUrl}/getEstadosWithOrgao`);
  }
}
